import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=a372e0d2&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=js&"
export * from "./SearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=a372e0d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372e0d2",
  null
  
)

export default component.exports